export default __webpack_public_path__ + "static/media/cover_title.15c1af31.svg";